export default "__VITE_ASSET__CLoEg9Nf__"